import { actions, mutations, state } from './users'

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
